import { TAO_KOE, TaoStorage } from './../libs';

const SessionStorage = TaoStorage.getSessionStorage();

class EmbedOverlay {
	constructor( embedEl ) {
		this.embedEl = embedEl;

		// Get Elements.
		this.overlayEl = this.embedEl.querySelector( '.mdl_embed__overlay' );
		this.templateEl = this.embedEl.querySelector( '.mdl_embed__template' );

		// Is this service managed via UserCentrics?
		this.service = this.overlayEl.dataset.service;

		// Accept Service on Buttonclick.
		this.overlayEl.querySelector( 'button' ).addEventListener( 'click', () => {
			if ( this.service ) {
				this.activateService();
			}
			this.replaceOverlay();
		} );

		if ( this.service ) {
			// UserCentrics managed services.
			window.addEventListener( 'UC_GENERAL', ( ev ) => {
				if ( ev.detail && ev.detail[ this.service ] ) {
					this.replaceOverlay();
				}
			} );

			// All other services.
			window.addEventListener( 'accepted_custom_service.koe', ( ev ) => {
				const services = ev.detail.services || [];
				if ( services.includes( this.service ) ) {
					this.replaceOverlay();
				}
			} );
		}
	}

	activateService() {
		const serviceInfo = window.UC_UI.getServicesBaseInfo().find( ( service ) => service.name === this.service );
		if ( serviceInfo ) {
			// Save in Usercentrics.
			window.UC_UI.acceptService( serviceInfo.id );
		} else {
			// Save Service in Session and dispatch Event.
			EmbedOverlay.addCustomService( this.service );
			EmbedOverlay.notifyCustomService();
		}
	}

	replaceOverlay() {
		if ( this.templateEl.isConnected ) {
			const newHtml = this.templateEl.innerHTML;
			const fragment = document.createRange().createContextualFragment( newHtml );

			this.templateEl.parentElement.appendChild( fragment );
			this.templateEl.remove();
			this.overlayEl.remove();

			this.embedEl.dispatchEvent( new CustomEvent( 'load_embed.koe', { bubbles: true } ) );
		}
	}

	static getCustomServices() {
		const fallback = SessionStorage.getItem( 'koe.service_consent_fallback' );
		try {
			return fallback ? JSON.parse( fallback ) : [];
		} catch ( error ) {
			return [];
		}
	}

	static addCustomService( service ) {
		const services = [].concat( EmbedOverlay.getCustomServices() || [], service );
		SessionStorage.setItem( 'koe.service_consent_fallback', JSON.stringify( services ) );
		return services;
	}

	static notifyCustomService() {
		const services = EmbedOverlay.getCustomServices() || [];
		if ( services.length > 0 ) {
			window.dispatchEvent( new CustomEvent( 'accepted_custom_service.koe', { detail: { services } } ) );
		}
		return services;
	}
}

const initEmbedOverlays = function() {
	// Initialise Overlays.
	const embedEls = document.querySelectorAll( '.mdl_embed' );
	embedEls.forEach( function( embedEl ) {
		if ( embedEl.querySelector( '.mdl_embed__overlay' ) ) {
			embedEl.KOE_EMBED_OVERLAY ??= new EmbedOverlay( embedEl );
		}
	} );

	// Dispatch Event for custom services.
	EmbedOverlay.notifyCustomService();
};

TAO_KOE.ready( 'embed.js', initEmbedOverlays );
